import React from "react";
const TermsAndConditions = () => {
  return (
    <div className="container p5 font-secondary black-contrai" id="content">
      <h2 className="text-center pb-3">
        End User License and Terms of Service
      </h2>
      <div className="font-14 font-weight-medium pt-3">
        Your use of this website, any applications and services provided through
        this website, and the opening of an account through this website with
        Taabl Co. (“Taabl”, “we”, “our”) is subject to this this End User
        License and Terms of Service (the “Terms of Service”). You must agree to
        comply with all of the provisions of the Terms of Service to use the
        Services on the website.
      </div>
      <br></br>
      <ol type="1">
        <li className="font-14 font-weight-medium pt-3">
          <b>The Services. </b> Through this website, Taabl provides you with
          certain services (the “Services”) in connection with your employer’s
          Employee Stock Participation Plan (“ESPP”). ESPPs allow employees to
          purchase shares of their employer’s stock on certain prices and terms.
          The Services offered by Taabl in connection with the Terms of Service
          include this website and all of its contents, design features, source
          code, algorithms, applications and data, educational materials about
          ESPPs offered through the website, information about participating in
          your employer’s ESPP and financing options if you choose to
          participate in the ESPP, including an opportunity to borrow money from
          Taabl. Any loans offered to you by Taabl will be governed by a
          separate loan agreement.
        </li>
        <br></br>
        <li>
          <b>Intellectual Property. </b> The Services are confidential and
          proprietary to Taabl and are protected by United States and
          international copyright, trademark, patent, trade secret and/or other
          intellectual property or proprietary rights laws (“intellectual
          property”). Taabl is the sole and exclusive owner of all intellectual
          property (including trademarks) included in the Services, and you
          neither have nor acquire any ownership interest, license, lease, or
          right to the Services except as provided herein.
        </li>
        <br></br>
        <li>
          <b>Limited License.</b> You may use the Services only in connection
          with your employer’s ESPP. We own and retain ownership of all rights
          of whatever nature in our intellectual property. Except as expressly
          set forth in the Terms of Service, we retain all rights and you are
          granted no rights in or to the Services. Unless otherwise expressly
          permitted in the Terms of Service, you may not:
          <ol type="a">
            <br></br>
            <li>
              sell, sublicense, distribute, display, store, copy, modify,
              decompile or disassemble, reverse engineer, translate or transfer
              our intellectual property in whole or in part, or as a component
              of any other product, service or material;
            </li>
            <br></br>
            <li>
              use our intellectual property or our third-party providers’
              intellectual property to create any derivative works or
              competitive products;
            </li>
            <br></br>
            <li>
              allow any third parties to access, use or benefit from our
              intellectual property in any way;
            </li>
            <br></br>
            <li>
              use the Services in any way that breaches the rights of any third
              party or violates any law, including export control and data
              privacy laws;
            </li>
            <br></br>
            <li>
              use the Services in any way that is unlawful or prohibited, or
              that is harmful or destructive to anyone or their property;
            </li>
            <br></br>
            <li>use the Services in a way that interferes with our network;</li>
            <br></br>
            <li>
              use the Services in a way that attempts to gain unauthorized
              access to our network;
            </li>
            <br></br>
            <li>
              use the Services in a way that impairs or limits our ability to
              operate this website or the Services or any other person’s ability
              to access and use this website or Services; or
            </li>
            <br></br>
            <li>
              use the Services to store or transmit unlawful or harmful content.
            </li>
          </ol>
        </li>
        <br></br>
        <li>
          <b>Privacy & Security.</b> For information on how Taabl uses, shares,
          and protects your personal information, please visit
          www.taabl.co/privacy.
        </li>
        <br></br>
        <li>
          <b>Modifications. </b> Taabl reserves the right at any time to modify
          the Terms of Service and to impose new or additional terms or
          conditions on the use of the Services by you. You will be notified of
          the modified Terms of Service through your user account.
        </li>
        <br></br>
        <li>
          <b>User Registration and Use of the Services.</b> You agree to provide
          accurate and complete registration information, and to maintain and
          promptly update such information to keep it current, and complete. You
          must be at least 18 years of age to accept the Terms of Service and to
          use the Services. Your account is to be used solely by you. Use of an
          account by more than one person violates the Terms of Service. You
          shall maintain the confidentiality of your password and notify Taabl
          immediately of any unauthorized use of your account.
        </li>
        <br></br>
        <li>
          <b>
            No Warranty. YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE
            SERVICES AND THIS WEBSITE IS AT YOUR SOLE RISK. TO THE MAXIMUM
            EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES, ANY WEB
            APPLICATIONS, AND THIS WEBSITE ARE PROVIDED “AS IS” AND “AS
            AVAILABLE,” WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND, AND
            TAABL HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH RESPECT TO
            THE SERVICES, ANY WEB APPLICATIONS, AND THIS WEBSITE, EITHER
            EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES AND/OR CONDITIONS OF MERCHANTABILITY, OF
            SATISFACTORY QUALITY, OF FITNESS FOR A PARTICULAR PURPOSE, OF
            ACCURACY, OF QUIET ENJOYMENT, AND OF NONINFRINGEMENT OF THIRD-PARTY
            RIGHTS. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY TAABL OR
            ITS AUTHORIZED REPRESENTATIVES SHALL CREATE A WARRANTY. SHOULD THE
            APPLICATION OR SERVICES PROVE DEFECTIVE, YOU ASSUME THE ENTIRE COST
            OF ALL NECESSARY SERVICING, REPAIR, OR CORRECTION.
          </b>
        </li>
        <br></br>
        <li>
          <b>
            Limitation of Liability. IN NO EVENT SHALL TAABL, ITS AFFILIATES,
            DIRECTORS, OFFICERS, LICENSORS, SUBCONTRACTORS, EMPLOYEES, AND/OR
            AGENTS BE LIABLE FOR INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, OR
            CONSEQUENTIAL DAMAGES (INCLUDING BUT NOT LIMITED TO DAMAGES FOR
            BREACH OF CONTRACT OR WARRANTY, OR FOR NEGLIGENCE OR STRICT
            LIABILITY) ARISING OUT OF OR IN CONNECTION WITH THE TERMS OF SERVICE
            OR YOUR USE OF, OR INABILITY TO USE, THE SERVICES AND THE WEBSITE,
            EVEN IF TAABL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            TAABL’S MAXIMUM LIABILITY FOR ANY AND ALL CLAIMS RELATED TO OR
            ARISING OUT OF THE TERMS OF SERVICE, REGARDLESS OF WHETHER THE CLAIM
            FOR SUCH DAMAGES IS BASED IN CONTRACT, TORT, OR ANOTHER LEGAL OR
            EQUITABLE THEORY, SHALL NOT EXCEED USD $50 IN THE AGGREGATE. THE
            FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY
            FAILS OF ITS ESSENTIAL PURPOSE. NOTHING IN THIS AGREEMENT LIMITS
            LIABILITY THAT CANNOT BE LIMITED UNDER LAW. THE LIMITATIONS IN THIS
            SECTION SHALL APPLY TO THE MAXIMUM EXTENT PERMITTED BY LAW.
          </b>
        </li>
        <br></br>
        <li>
          <b>
            Disclaimers.
            <ol type="a">
              <li>
                WE ARE NOT PROVIDING FINANCIAL, TAX AND ACCOUNTING, LEGAL,
                COMPLIANCE OR ANY OTHER PROFESSIONAL ADVICE BY ALLOWING YOU TO
                ACCESS AND USE THE SERVICES. YOUR DECISIONS MADE IN RELIANCE ON
                THE SERVICES OR YOUR INTERPRETATIONS OF OUR DATA ARE YOUR OWN
                FOR WHICH YOU HAVE FULL RESPONSIBILITY. TO THE EXTENT PERMITTED
                BY LAW AND THIS AGREEMENT, WE ARE NOT RESPONSIBLE FOR ANY
                DAMAGES RESULTING FROM ANY DECISIONS BY YOU.
              </li>
              <li>
                YOU ACKNOWLEDGE THERE ARE INHERENT RISKS IN INTERNET
                CONNECTIVITY AND THE USE OF THE SERVICES THAT COULD RESULT IN
                THE LOSS OR COMPROMISE OF YOUR PERSONAL DATA. TO THE EXTENT
                PERMITTED BY LAW AND THIS AGREEMENT, TAABL ASSUMES NO LIABILITY
                FOR ANY DAMAGE, THEFT OR LOSS TO YOUR PERSONAL DATA RESULTING
                FROM THE ACTS OR OMISSIONS OF ANY THIRD PARTY, INCLUDING,
                WITHOUT LIMITATION, ANY UNAUTHORIZED PHYSICAL OR NON-PHYSICAL
                ACCESS (SUCH AS HACKING). ANY SUCH DAMAGE OR LOSS WILL BE THE
                EXCLUSIVE RESPONSIBILITY OF THE THIRD PARTY WHO CAUSED SUCH LOSS
                OR DAMAGE.
              </li>
            </ol>
          </b>
        </li>
        <br></br>
        <li>
          <b>Taabl’s Liability.</b> The provisions in sections 8 and 9 above do
          not limit Taabl’s liability for gross negligence and willful
          misconduct.
        </li>
        <br></br>
        <li>
          <b>Indemnification.</b> You will indemnify and defend Taabl and its
          employees, officers, directors, agents and representatives against any
          claims, including claims by regulators and government agencies, that
          arise out of or are related to your use of the Services IN VIOLATION
          OF THE TERMS OF SERVICE or applicable law.
        </li>
        <br></br>
        <li>
          <b>Termination.</b>Taabl may suspend or terminate your access to and
          use of the Services at any time and for any reason, with or without
          notice. If your access to and use of the Services is suspended or
          terminated, you are still subject to the terms of the Terms of
          Service.
        </li>
        <br></br>
        <li>
          <b>Force Majeure.</b> We are not liable for any damages or failure to
          perform our obligations under the Agreement because of circumstances
          beyond our reasonable control.
        </li>
        <br></br>
        <li>
          <b>Governing Law, Venue, and Jurisdiction.</b> To the extent not
          inconsistent with applicable law, the Terms of Service and any
          dispute, disagreement, or issue of construction or interpretation
          arising hereunder whether relating to its execution, its validity, the
          obligations provided herein or performance shall be governed or
          interpreted according to the laws of the State of UTAH without regard
          to choice of law considerations. Any action, suit or proceeding
          arising out of, under or in connection with the Terms of Service shall
          be brought and determined in the appropriate federal or state court in
          the State of UTAH and in no other forum. The parties hereby
          irrevocably and unconditionally submit to the personal jurisdiction of
          such courts and agree to take any and all action necessary to submit
          to the jurisdiction of such courts in any such suit, action or
          proceeding arising out of or relating to the Terms of Service.
        </li>
        <br></br>
        <li>
          <b>Notices.</b> Any notices sent to you pursuant to the Terms of
          Service will be provided to you through your user account.
        </li>
        <br></br>
        <li>
          <b>Assignment.</b> You may not assign or transfer your rights or
          obligations under the Terms of Service to any party. Taabl may assign
          the Terms of Service in their entirety and without your consent to an
          affiliate of Taabl or any entity in connection with a merger,
          acquisition, corporate reorganization, or sale of all or substantially
          all of Taabl’s stock or assets.
        </li>
        <br></br>
        <li>
          <b>Severability.</b> If any provision in the provisions of the Terms
          of Service is held invalid or unenforceable for any reason, the
          remaining provisions shall continue in full force and effect.
        </li>
        <li>
          <br></br>
          <b>No Waiver.</b> Taabl’s failure to enforce any provision in the
          Terms of Service shall not be construed as a waiver of that provision.
        </li>
        <br></br>
        <li>
          <b>Injunctive Relief.</b> You agree in the event of you use the
          Services in violation of the Terms of Service, or the threat of either
          of the foregoing, Taabl shall be entitled to injunctive relief.
        </li>
        <br></br>
        <li>
          <b>Feedback.</b> You grant Taabl a perpetual, irrevocable,
          transferable, non-exclusive right to use any comments, suggestions,
          ideas or recommendations you provide related to any of our products or
          services in any manner and for any purpose.
        </li>
        <br></br>
        <li>
          <b>Entire Agreement.</b> The Terms of Service constitutes the entire
          agreement between the parties and supersede all understandings,
          agreements (oral and written), or representations with respect to the
          subject matter hereof. The Terms of Service may only be
          amended,revised or modified with our written consent. Each party
          acknowledges that no representation, inducement or condition not set
          forth herein has been made or relied upon by either party.
        </li>
      </ol>
      <div className="font-14 font-weight-medium pt-3">
        In order to use the payment functionality of Taabl’s application, you
        must open a "Dwolla Account" provided by Dwolla, Inc. and you must
        accept the{" "}
        <a className="text-primary" href="https://www.dwolla.com/legal/tos/">
          {" "}
          Dwolla Terms of Service
        </a>{" "}
        and{" "}
        <a className="text-primary" href="https://www.dwolla.com/legal/privacy">
          Privacy Policy
        </a>
        . Any funds held in or transferred through your Dwolla Account are held
        or transferred by Dwolla's{" "}
        <a
          className="text-primary"
          href="https://www.dwolla.com/legal/about-our-financial-institution-partners/"
        >
          financial institution partners
        </a>
        . You must be at least 18 years old to create a Dwolla Account. You
        authorize us to collect and share with Dwolla your personal information
        including full name, date of birth, social security number, physical
        address, email address and financial information, and you are
        responsible for the accuracy and completeness of that data. You
        understand that you will access and manage your Dwolla Account through
        Taabl’s application, and Dwolla account notifications will be sent by
        Taabl, not Dwolla. We will provide customer support for your Dwolla
        Account activity, and can be reached at{" "}
        <a className="text-primary" href="https://www.taabl.co/">
          taabl
        </a>
        {""}.
      </div>
      <div className="font-14 font-weight-medium pt-3">
        Questions about the Terms of Service should be directed to: Email{" "}
        <a href="mailto:support@taabl.co">
          <b>support@taabl.co</b>
        </a>{" "}
        or by visiting{" "}
        <a href="www.taabl.co/support" target="_blank">
          <b>www.taabl.co/support</b>
        </a>
      </div>
    </div>
  );
};
export default TermsAndConditions;
